<template>
  <header class="header-component">
    <dx-toolbar class="header-toolbar">
      <dx-item location="before" css-class="header-branding">
        <template #default>
          <div class="branding-container">
            <img src="../assets/logo.jpg" alt="Logo" class="logo-image" />
            <div class="title-container">
              <div class="main-title">{{ $t('common.drc') }}</div>
              <div class="sub-title">{{ $t('common.ministry') }}</div>
            </div>
          </div>
        </template>
      </dx-item>

      <dx-item location="after" css-class="header-controls">
        <template #default>
          <div class="controls-container">
            <!-- Language Switcher Component -->
            <language-switcher />

            <div class="user-profile">
               <span class="welcome-text">{{ $t('header.welcome') }} {{ pr_First_Name }}</span>
               <dx-button class="user-button authorization" styling-mode="text">
                 <user-panel :user="user" :menu-items="userMenuItems" menu-mode="context">
                    <div class="user-initial-circle">{{ userInitial }}</div>
                 </user-panel>
               </dx-button>
            </div>
          </div>
        </template>
      </dx-item>
       <template #menuUserItem>
          <user-panel :user="user" :menu-items="userMenuItems" menu-mode="list" />
       </template>
    </dx-toolbar>
  </header>
</template>

<script>
import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import auth from "../auth";
import UserPanel from "./user-panel";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import { mapState, mapActions } from 'vuex'
import { LOGOUT } from '@/store/_actiontypes'

export default {
  props: {
    // These props are no longer needed for the new design but kept if used elsewhere
    menuToggleEnabled: Boolean,
    toggleMenuFunc: Function,
    logOutFunc: Function,
  },
    // computed: {

    // },
  created() {
    // In a real app, this data would come from your auth service
    // auth.getUser().then((e) => this.user = e.data);
    // For this example, we'll use the static data from the image.
    this.user = { name: "Bracongo SA" };
  },
  data() {
    return {
      user: {},
    };
  },
  computed: {
    ...mapState({
      pr_First_Name: state => state?.user?.user?.data?.admistration_Details?.pr_First_Name,
      pr_Last_Name: state => state?.user?.user?.data?.admistration_Details?.pr_Last_Name
    }),
    username() {
      return this.pr_First_Name + " " +this.pr_Last_Name
    },
    userInitial() {
      return this.username && this.username ? this.username.charAt(0).toUpperCase() : "";
    },
    userMenuItems() {
      return [
        {
          text: this.$t('header.profile'),
          icon: "user",
          onClick: this.onProfileClick,
        },
        {
          text: this.$t('header.logout'),
          icon: "runner",
          onClick: this.onLogoutClick,
        },
      ];
    }
  },
  methods: {
    ...mapActions("user", [ LOGOUT ]),
    onLogoutClick() {
      this.LOGOUT().then(res => {
        this.$router.push('/login')
      })
      .catch(error => {
        console.log(error)
      })      
    },
    onProfileClick() {
      this.$router.push({
        path: "/profile",
        query: { redirect: this.$route.path },
      });
    },
  },
  components: {
    DxButton,
    DxToolbar,
    DxItem,
    UserPanel,
    LanguageSwitcher,
  },
};
</script>

<style lang="scss">
// Make sure these paths are correct for your project structure
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";

// Main toolbar styling
.header-component .dx-toolbar.header-toolbar {
  background-color: #00539f; // The blue from the image
  color: white;
  padding: 0 20px;
  height: 64px;
}

// Container for logo and title
.branding-container {
  display: flex;
  align-items: center;

  .logo-image {
    height: 40px;
    margin-right: 15px;
  }

  .title-container {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
    .main-title {
      font-weight: bold;
      font-size: 16px;
    }
    .sub-title {
      font-size: 14px;
      font-weight: 300;
    }
  }
}

// Container for right-side controls
.controls-container {
  display: flex;
  align-items: center;
  gap: 20px;
}

// User profile section styles
.user-profile {
  display: flex;
  align-items: center;
  color: white;
  
  .welcome-text {
    margin-right: 15px;
    font-size: 14px;
  }

  // This ensures the button wrapping the user panel doesn't have extra padding
  .dx-button.user-button {
    padding: 0;
    
    .dx-button-content {
      padding: 0;
    }
  }

  .user-initial-circle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
    background-color: #f37021; // The orange from the image
    border-radius: 50%;
    color: white;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
  }
}

// Ensure items are spaced correctly
.dx-toolbar-before {
  flex-grow: 1;
}

.dx-toolbar-after {
  flex-grow: 0;
}
</style>